export default __webpack_public_path__ + "static/media/03_LONELY.fab07dfe.png";